<template>
  <div class="radioItem" :class="{'radioItemPicture' :radioPicture}">
    <!-- 只有文字 -->
    <div v-if="radioPicture == false" class="radioOption">
      <div style="display: inline-block" v-for="(option, index) in radioList" :key="index">
        <el-radio
          @input="selectRadio"
          :option="option"
          :label="option.label"
          :value="option.label"
          v-model="Radiovalue"
          style="height:30px;display: inline-block;line-height: 30px;"
        ></el-radio>
        <input
          class="input_bgc"
          style="width: 300px; z-index:99;"
          v-if="option.other === true && (Radiovalue == option.name)"
          v-model="option.otherOPtionAnswer"
          :placeholder="option.otherPrompt ? option.otherPrompt : '请填写说明'"
        />
      </div>
    </div>
    <!-- 有文字和图片 -->
    <div
      class="radioPicMain"
      v-else
      style="width:110px;display:inline-block;"
      v-for="(option, index) in radioList"
      :key="index"
    >
      <div class="radioPic" :class="(Radiovalue == option.name) ? 'radioPicHover' : '' ">
        <div class="radioPic_content" :class="{'radioPic_noImage' :option.images.length === 0}">
          <img v-for="(i, index) in option.images" :key="index" :src="i" />
          <el-radio
            @input="selectRadio"
            :option="option"
            :label="option.label ? option.label : index"
            :value="option.label"
            v-model="Radiovalue"
          ></el-radio>
        </div>
      </div>
      <!-- <input
        class="input_bgc"
        style="width: 100%; z-index:99;margin-top: 10px;"
        v-if="option.other === true && (Radiovalue == option.name)"
        v-model="option.otherOPtionAnswer"
        :placeholder="option.otherPrompt ? option.otherPrompt : '请填写说明'"
      />-->
    </div>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      //  radioItem: this.item,
      radioOther: {},
      Radiovalue: '', // 0-0
      radioIndex: -1,
      radioPlaceholder: '其他选项提示说明',
      //  判断是否有图片
      radioPicture: false,
      // 判断是否有弹出input框
      showOtherinput: false,
      showOtherIndex: -1,
      showOtherItem: {},
      radioList: [],
    }
  },
  created: function () {
    if (
      this.item.value.singleChoiceAttribute.answer &&
      this.item.value.singleChoiceAttribute.answer.value != ''
    ) {
      this.Radiovalue = this.item.value.singleChoiceAttribute.answer.name
      // this.radioOther = this.item.value.singleChoiceAttribute.answer
    } else {
      this.item.value.singleChoiceOptions.map((i, index) => {
        console.log(i.defaultValue)
        if (i.defaultValue == true) {
          this.Radiovalue = i.name
          this.item.value.singleChoiceAttribute.answer = i
        }
      })
    }
    // 默认值
    this.item.value.singleChoiceOptions.map((i, index) => {
      console.log(i.defaultValue)
      if (i.images.length != 0) {
        this.radioPicture = true
      }
      // if (i.defaultValue == true) {
      //   this.Radiovalue = i.name
      //   this.item.value.singleChoiceAttribute.answer = i
      // }
    })
    this.selectOptionsRadio(this.item, this.pindex)
    // }
    // if (this.showOtherIndex >= 0) {
    //   this.item.value.singleChoiceOptions.splice(this.showOtherIndex, 1);
    //   this.item.value.singleChoiceOptions.push(this.showOtherItem);
    // }
    // console.log(this.radioPicture);
  },
  mounted: function () {},
  methods: {
    // 单选题替换label和value 量表题
    selectOptionsRadio: function (select, pindex) {
      const singleChoiceOptions = select.value.singleChoiceOptions
      singleChoiceOptions.forEach((item, index) => {
        this.$set(item, 'label', item.name)
        this.$set(item, 'value', pindex + '-' + index)
        // this.$set(item, 'value', item.name)
        this.$set(item, 'otherOPtionAnswer', '')
        if (this.item.value.singleChoiceAttribute.answer.name == item.name) {
          item.otherOPtionAnswer =
            this.item.value.singleChoiceAttribute.answer.otherOPtionAnswer
        }
      })
      this.radioList = singleChoiceOptions
      //       console.log(this.radioList)
    },

    selectRadio(data) {
      var selectItem = this.radioList.filter((_item) => {
        return data == _item.name
      })
      this.radioOther = selectItem[0]
      this.item.value.singleChoiceAttribute.answer = this.radioOther
      console.log(this.radioOther)
      this.$emit('Radiovalue', this.radioOther)
    },
  },
  computed: {},
  watch: {},
}
</script>
<style scoped  lang="less">
/deep/.el-radio {
  white-space: normal;
}

.radioItem {
  width: 100%;
  clear: both;
  position: relative;
}
.radioItemPicture {
  white-space: pre-wrap !important;
}
.border-bottom-1px:after {
  border: none;
}
.marginBottom {
  margin-bottom: 40px;
}
/* 只有文字 */

.radioItem .radioOption .el-radio {
  /* border: 1px solid rgb(220, 220, 220) !important; */
  margin-bottom: 10px;
  height: 33px;
  vertical-align: middle;
  border-radius: 5px;
  padding-left: 10px;
  /* background-color: rgb(246, 248, 252); */
  color: #738299;
  font-weight: 400;
}
.radioItem .radioOption .el-radio.el-radio_selected {
  border: 1px solid rgb(66, 134, 241) !important;
}
.radioItem .radioOption .el-radio-label {
  font-size: 14px;
  line-height: 14px;
}
/* 有文字和图片 */
.radioPic {
  width: 100%;
  /* float:left; */
  display: inline-block;
  /* position: relative; */
}
.radioPicHover {
  /* border: 1px solid rgb(66, 134, 241); */
  border-radius: 3px;
}
.radioPic_content {
  position: relative;
  width: 100%;
  /* height: 200px; */
  padding: 10px;
  box-sizing: border-box;
  border-radius: 3px;
  text-align: center;
}
.radioPicMain {
  margin-bottom: 10px;
}
.radioPicMain:nth-child(2n-1) {
  margin-right: 3%;
}
.radioPic_content img {
  width: 100%;
  /* height: 150px; */
  border-radius: 5px;
  /* margin-bottom: 10px; */
}
.radioPic_content input {
  opacity: 0;
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
}
.radioPic .el-radio-wrap.border-bottom-1px {
  font-size: 14px;
}
.radioPic_content .el-radio {
  /* position: absolute; */
  bottom: 0;
}
.radioOption .el-radio-wrap.border-bottom-1px {
  font-size: 14px;
}
.radio_pic .radioOption {
  width: 38%;
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
  margin-bottom: 10px;
}
.radioItem .input_bgc {
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
  margin-bottom: 10px;
  font-size: 14px;
  outline: none;
}
.radioItem .radioInputPic {
  /* display:inline-block; */

  float: left;
  /* position: absolute; */
  bottom: -44px;
  left: 0;
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
  margin-bottom: 10px;
  outline: none;
  margin-top: 10px;
}
</style>


